import { DAppConnector } from "@hashgraph/hedera-wallet-connect";
import { filter } from "rxjs";
import { LedgerId } from "@hashgraph/sdk";
import { WalletConnectModal } from "@walletconnect/modal";
import { HederaNetwork, WalletLockedEvent, WalletUnlockedEvent, } from "../models/blade";
import { noSessionError } from "../models/errors";
import { getAccountIDsFromSigners } from "../helpers/utils";
import { BaseConnectorStrategy } from "../strategies/base-connector.strategy";
import { pairingRejected } from "../models/errors";
export class WalletConnectStrategy extends BaseConnectorStrategy {
    constructor(meta, projectId) {
        super();
        this.activeSigner = null;
        this.signers = [];
        this.subscriptions = [];
        this.modal = new WalletConnectModal({
            projectId: projectId !== null && projectId !== void 0 ? projectId : "0301c380a9a2a23af77ce32611c158e0"
        });
        this.modal.subscribeModal((state) => {
            var _a;
            (_a = this.modalStateCallback) === null || _a === void 0 ? void 0 : _a.call(this, state);
        });
        this.dAppConnector = new DAppConnector(meta);
        this.dAppConnector.init([WalletUnlockedEvent, WalletLockedEvent], ["handshake"]);
    }
    onWalletLocked(callback) {
        const lockedSub = this.dAppConnector.$events
            .pipe(filter((e) => e.name === WalletLockedEvent))
            .subscribe(callback);
        this.subscriptions.push(lockedSub);
    }
    onWalletUnlocked(callback) {
        const updatedSub = this.dAppConnector.$events
            .pipe(filter((e) => e.name === WalletUnlockedEvent))
            .subscribe(callback);
        this.subscriptions.push(updatedSub);
    }
    async createSession(params) {
        try {
            const networkName = ((params === null || params === void 0 ? void 0 : params.network) || HederaNetwork.Mainnet).toLowerCase();
            const data = await this.dAppConnector.prepareConnectURI(LedgerId.fromString(networkName));
            let closePromise;
            if (data) {
                if (data.uri) {
                    await this.modal.openModal({ uri: data.uri });
                    closePromise = new Promise((reject) => {
                        this.modalStateCallback = ({ open }) => {
                            if (!open) {
                                reject(pairingRejected());
                            }
                        };
                    });
                }
                // @ts-ignore
                const session = await Promise.race([data.approval(), closePromise]);
                this.modalStateCallback = undefined;
                await this.onSessionChange(session);
                return getAccountIDsFromSigners(this.signers);
            }
            else {
                const existingSession = await this.dAppConnector.checkPersistedState();
                if (existingSession) {
                    await this.onSessionChange(existingSession);
                    return getAccountIDsFromSigners(this.signers);
                }
                return [];
            }
        }
        catch (e) {
            throw e;
        }
        finally {
            this.modalStateCallback = undefined;
            this.modal.closeModal();
        }
    }
    async killSession() {
        this.subscriptions.forEach(s => s.unsubscribe());
        this.subscriptions = [];
        return this.dAppConnector.disconnect();
    }
    async selectAccount(accountId) {
        const account = this.signers.find(s => s.getAccountId().toString() === accountId);
        if (!this.activeSigner || !account && accountId) {
            throw noSessionError();
        }
        this.activeSigner = account || this.activeSigner;
        return this.activeSigner;
    }
    get initialized() {
        var _a;
        return Boolean((_a = this.dAppConnector) === null || _a === void 0 ? void 0 : _a.initialized);
    }
}
